import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { ClientService } from '@teem/services/client.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { client as ClientApi } from '@teem/constants/api';
import { Proposal } from '@teem/models/proposal';
import { Client } from '@teem/models/client';

@Component({
  selector: 'edit-proposal-client-detail',
  templateUrl: './client-detail.component.html',
  styles: []
})
export class ClientDetailComponent implements OnInit {
  @Input() proposal: Proposal; 
	@Output() onComplete: EventEmitter<any> = new EventEmitter();
	
  clientOption: string = null;
  newClientForm: FormGroup;
  clientId: number = null;
  submitted: boolean = false;
  clientListApi: string = ClientApi.list;
  selectedClient: any;

  constructor(
  	private fb: FormBuilder,
    private clientService: ClientService,
    private loaderService: LoaderService) { }

  ngOnInit(): void {
  	this.newClientForm = this.fb.group({
  		first_name: ['', Validators.required],
  		last_name: [''],
  		company: [''],
  		email: ['', [Validators.email]],
  		phone: ['', [Validators.maxLength(10)]]
  	});

    this.selectedClient = {
      id: this.proposal.client_id,
      full_name: this.proposal.client_name,
      email: this.proposal.client_email
    }

    this.clientId = this.proposal.client_id;

    this.clientOption = "existing";
  }

  selectClient(val: any) {
    if(val.id && val.text) {
      this.selectedClient = {
        id: val.id,
        full_name: val.text,
        email: val.email
      }
    }
  }

	setClientOption(state: boolean, value) {

		this.submitted = false;

    this.clientOption = state ? value : null;
	}

  submit() {
    this.submitted = true;

    if(this.clientOption == 'new') {
      if(this.newClientForm.valid) {
        this.loaderService.startLoading();

        this.clientService.create(this.newClientForm.value).subscribe((data:any) => {

          this.loaderService.stopLoading();
          
          this.selectedClient = {
            id: data.id,
            full_name: data.full_name,
            email: data.email
          }
          this.clientId = data.id;
          
          this.submitted = false;
          this.clientOption = 'existing';
          this.newClientForm.reset();

          this.onComplete.emit(this.selectedClient);
          
        }, err => {
          this.loaderService.stopLoading();

          // Set server side error
          if(err.status === 422) {
            if(err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.newClientForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }
          
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        });
        
      }
    } else if(this.clientOption == 'existing' && this.clientId) {
      this.onComplete.emit(this.selectedClient)
    } else {
      Swal.fire('', i18n.error.select_client,'warning')
    }
  }
}
